module.exports = __webpack_public_path__ + "static/media/Mara_Headshot.2344e914.png";